var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"font-size":"15px"},attrs:{"id":"label","options":_vm.labels,"label":"name","multiple":true,"placeholder":"Type"},on:{"input":_vm.filterTable},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }